import { IStore } from '../../index';
import { INotificationsStore } from '../store';
import { TOmitFirstArg } from '../../Interfaces/OmitFirstArg';

type TPushSuccessNotificationActionWithState = (
  state: IStore,
  text: string
) => { notifications: INotificationsStore };

export const pushSuccess: TPushSuccessNotificationActionWithState = (state, text) => {
  return {
    notifications: {
      ...state.notifications,
      message: {
        status: 'unread',
        text,
        type: 'success'
      },
      open: true
    }
  };
};

export type TPushNotificationSuccessAction = TOmitFirstArg<TPushSuccessNotificationActionWithState>;
